/* ── AIMA Landing JS ── */
(function() {
  'use strict';

  var AIMA_VARIANT_ID = window.AIMA_VARIANT_ID || 0;
  var AIMA_PRICE_LABEL = window.AIMA_PRICE_LABEL || '';
  var aimaProdQty = 1;

  if (!AIMA_VARIANT_ID) {
    console.warn('AIMA: variant ID not found — cart disabled');
  }

  /* ── GALLERY SWITCH ── */
  window.aimaSwitchImg = function(thumb, src) {
  var galleryMain = document.getElementById('galleryMain');
  if (galleryMain) galleryMain.classList.add('is-switching');
  var mainImg = document.getElementById('gallery-main-img');
  if (mainImg) {
    /* Si la imagen tiene srcset, el navegador ignora el cambio de src.
       Lo sacamos al cambiar de foto para que se actualice de una. */
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
  }
  if (galleryMain) requestAnimationFrame(function() { galleryMain.classList.remove('is-switching'); });
    document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

  /* ── PRODUCT QTY ── */
  window.aimaChangeProductQty = function(delta) {
    var newQty = Math.max(1, (window._aimaProdQty || aimaProdQty || 1) + delta);
    aimaProdQty = newQty;
    window._aimaProdQty = newQty;
    var el = document.getElementById('aima-prod-qty');
    if (el) el.textContent = newQty;
  };

  /* ── ADD TO CART (hero / cta buttons) ── */
  window.aimaAddToCart = function() {
    if (!window.AIMA_VARIANT_ID) return;
    var btns = [document.getElementById('aima-hero-btn'), document.getElementById('aima-cta-btn')];
    btns.forEach(function(b) { if (b) { b.disabled = true; b.textContent = 'Agregando…'; } });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: window.AIMA_VARIANT_ID, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      aimaLoadCart(true);
    })
    .catch(function(err) {
      console.error('AIMA add error:', err);
      aimaRestoreBtns();
    });
  };

  /* ── ADD TO CART (product section button) ── */
  /* Solo se define si aima-product.liquid no la definió ya (product page) */
  if (!window.aimaAddToCartProd) window.aimaAddToCartProd = function() {
    if (!window.AIMA_VARIANT_ID) return;
    var btn = document.getElementById('aima-prod-add-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: window.AIMA_VARIANT_ID, quantity: aimaProdQty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      aimaLoadCart(true);
      if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
    })
    .catch(function(err) {
      console.error('AIMA prod add error:', err);
      if (btn) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
    });
  };

  /* ── COPY PROMO CODE ── */
  window.aimasCopyCode = function() {
    var btn = document.getElementById('aima-copy-btn');
    var msg = document.getElementById('promo-copy-msg');
    var codeEl = document.getElementById('aima-promo-code');
    var code = codeEl ? codeEl.textContent.trim() : 'AIMA15';
    function onCopied() {
      if (btn) { btn.textContent = '¡COPIADO!'; }
      if (msg) { msg.style.display = 'block'; }
      setTimeout(function() {
        if (btn) btn.textContent = 'COPIAR';
        if (msg) msg.style.display = 'none';
      }, 2000);
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(onCopied);
    } else {
      var el = document.createElement('textarea');
      el.value = code; document.body.appendChild(el); el.select();
      document.execCommand('copy'); document.body.removeChild(el);
      onCopied();
    }
  };

  /* ── LOAD CART ── */
  function aimaLoadCart(openDrawer) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      aimaRenderCart(cart);
      aimaUpdateBadge(cart.item_count);
      if (openDrawer) { aimaRestoreBtns(); window.aimaOpenCart(); }
    })
    .catch(function(err) { console.error('AIMA load error:', err); });
  }
  window.aimaLoadCart = aimaLoadCart;

  /* ── UPSELL STATE ── */
  function aimaUpdateUpsellState(cartItems) {
    var upsell = document.getElementById('aima-upsell');
    var cartItems_ = cartItems || [];
    var hasCartItems = cartItems_.length > 0;

    // IDs de variante y de producto en el carrito
    var cartVariantIds = cartItems_.map(function(i) { return i.variant_id; });
    var cartProductIds = cartItems_.map(function(i) { return i.product_id; });

    var visibleCount = 0;
    document.querySelectorAll('.aima-upsell-item').forEach(function(item) {
      var vid = parseInt(item.dataset.variantId, 10);
      var pid = parseInt(item.dataset.productId, 10);
      var inCart = cartVariantIds.indexOf(vid) !== -1 || cartProductIds.indexOf(pid) !== -1;
      if (inCart) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
        visibleCount++;
      }
    });

    // Mostrar bloque solo si hay items en carrito Y hay recomendados visibles
    if (upsell) upsell.style.display = (hasCartItems && visibleCount > 0) ? 'block' : 'none';
  }

  /* ── ADD UPSELL PRODUCT ── */
  window.aimaAddUpsell = function(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status >= 400) {
        btn.disabled = false;
        btn.textContent = 'Agregar';
        return;
      }
      aimaLoadCart(false);
    })
    .catch(function(err) {
      console.error('AIMA upsell add error:', err);
      btn.disabled = false;
      btn.textContent = 'Agregar';
    });
  };

  /* ── RENDER ITEMS ── */
  function aimaRenderCart(cart) {
    var el = document.getElementById('aima-drawer-items');
    var sub = document.getElementById('aima-subtotal');

    aimaUpdateUpsellState(cart.items);

    if (!cart.items || cart.items.length === 0) {
      if (el) el.innerHTML = '<p class="aima-cart-empty">Tu carrito está vacío</p>';
      if (sub) sub.textContent = aimaMoney(0);
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var img = item.image || '';
      html += '<div class="aima-cart-item">';
      if (img) html += '<img src="' + img + '" alt="' + item.product_title + '" loading="lazy">';
      html += '<div class="aima-item-info">';
      html += '<p class="aima-item-title">' + item.product_title + '</p>';
      html += '<p class="aima-item-price">' + aimaMoney(item.line_price) + '</p>';
      html += '<div class="aima-qty-row">';
      html += '<button class="aima-qty-btn" onclick="aimaChangeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>';
      html += '<span class="aima-qty-num">' + item.quantity + '</span>';
      html += '<button class="aima-qty-btn" onclick="aimaChangeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>';
      html += '</div></div>';
      html += '<button class="aima-remove-btn" onclick="aimaChangeQty(\'' + item.key + '\',0)" aria-label="Eliminar">✕</button>';
      html += '</div>';
    });

    if (el) el.innerHTML = html;
    if (sub) sub.textContent = aimaMoney(cart.total_price);
  }

  /* ── CHANGE QUANTITY ── */
  window.aimaChangeQty = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      aimaRenderCart(cart);
      aimaUpdateBadge(cart.item_count);
    })
    .catch(function(err) { console.error('AIMA qty error:', err); });
  };

  /* ── HELPERS ── */
  function aimaMoney(cents) {
    return '$ ' + Math.round(cents / 100).toLocaleString('es-AR');
  }

  function aimaUpdateBadge(count) {
    var badge = document.getElementById('aima-nav-badge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-flex' : 'none';
  }

  function aimaRestoreBtns() {
    var heroBtn = document.getElementById('aima-hero-btn');
    var ctaBtn  = document.getElementById('aima-cta-btn');
    if (heroBtn) { heroBtn.disabled = false; heroBtn.textContent = 'Agregar al carrito — ' + AIMA_PRICE_LABEL; }
    if (ctaBtn)  { ctaBtn.disabled  = false; ctaBtn.textContent  = 'Agregar al carrito — ' + AIMA_PRICE_LABEL; }
  }

  /* ── DRAWER ── */
  window.aimaOpenCart = function() {
    var ov = document.getElementById('aima-overlay');
    var dr = document.getElementById('aima-drawer');
    if (ov) ov.classList.add('active');
    if (dr) dr.classList.add('active');
    document.body.style.overflow = 'hidden';
    aimaLoadCart(false);
  };

  window.aimaCloseCart = function() {
    var ov = document.getElementById('aima-overlay');
    var dr = document.getElementById('aima-drawer');
    if (ov) ov.classList.remove('active');
    if (dr) dr.classList.remove('active');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') window.aimaCloseCart();
  });

  /* ── TABS ── */
  window.showPro = function(id, e) {
    document.querySelectorAll('.pro-content').forEach(function(el) { el.classList.remove('active'); });
    document.querySelectorAll('.pro-tab').forEach(function(el) { el.classList.remove('active'); });
    var content = document.getElementById('pro-' + id);
    if (content) content.classList.add('active');
    if (e && e.target) e.target.classList.add('active');
  };

  /* ── FAQ ── */
  window.toggleFaq = function(el) {
    var item = el.parentElement;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  /* ── GALLERY HOVER ZOOM (desktop only) ── */
  (function() {
    var gm = document.getElementById('galleryMain');
    if (!gm || window.matchMedia('(hover: none)').matches) return;
    gm.addEventListener('mousemove', function(e) {
      var r = gm.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width  * 100).toFixed(2) + '%';
      var y = ((e.clientY - r.top)  / r.height * 100).toFixed(2) + '%';
      gm.style.setProperty('--zoom-x', x);
      gm.style.setProperty('--zoom-y', y);
    }, { passive: true });
    gm.addEventListener('mouseleave', function() {
      gm.style.setProperty('--zoom-x', '50%');
      gm.style.setProperty('--zoom-y', '50%');
    }, { passive: true });
  })();

  /* ── SCROLL REVEAL ── */
  (function() {
    if (!('IntersectionObserver' in window)) return;
    var HERO_CLASS = 'aima-hero-section';
    var STAGGER_SELECTORS = [
      '.benefit-item', '.review-card', '.spec-row', '.comparison-row',
      '.faq-item', '.trust-item', '.pro-tab'
    ];
    /* Mark top-level sections (skip hero — already animates on load) */
    document.querySelectorAll('.aima-section').forEach(function(el) {
      if (!el.closest('.' + HERO_CLASS)) el.classList.add('aima-reveal');
    });
    /* Mark staggered children */
    STAGGER_SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el, i) {
        el.classList.add('aima-reveal');
        el.style.animationDelay = (i * 0.07) + 's';
      });
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.aima-reveal').forEach(function(el) { io.observe(el); });
  })();

  /* ── INIT ── */
  aimaLoadCart(false);
})();
